import { useContext } from "react";

import AppContext from "../../../../AppContext";
import useReleaseOpsReservation from "../Hooks/UseReleaseOpsReservation";

const AppContextUseReleaseReservation = () => {
  const { leadIdCState, patient } = useContext(AppContext);
  return useReleaseOpsReservation({ patientId: patient.id, leadId: leadIdCState });
};

export default AppContextUseReleaseReservation;
